import { render } from "./contract-prod.vue?vue&type=template&id=b025b88a&scoped=true"
import script from "./contract-prod.vue?vue&type=script&lang=js"
export * from "./contract-prod.vue?vue&type=script&lang=js"

import "./contract-prod.vue?vue&type=style&index=0&id=b025b88a&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b025b88a"]])

export default __exports__